import { eula_es } from './eula_es';

export const locale_es = {
  ...eula_es,
  Organization: 'Organización',
  AreYouSureRemoveMemberFromGroupParam: '¿Está seguro de querer eliminar a {0} miembro del grupo?',
  AreYouSureRemoveMembersFromGroupParam: '¿Está seguro de que desea eliminar a {0} miembros del grupo?',
  RowsSelected: 'fila(s) seleccionada(s)',
  AddToMembers: 'Agregar a miembros',
  AssignRolesToGroup: 'Asignar roles al grupo',
  Confirm: 'Confirmar',
  Name: 'Nombre',
  Reset: 'Restablecer',
  SaveChanges: 'Guardar cambios',
  GeneralProperties: 'Propiedades Generales',
  AddMembersToGroup: 'Agregar miembros al grupo',
  AddMembers: 'Agregar miembros',
  UnexpectedError: 'Error inesperado',
  Confirmation: 'Confirmación',
  DeleteMember: 'Eliminar miembro',
  DeleteMembers: 'Eliminar miembros',
  Cancel: 'Cancelar',
  User: 'Usuario',
  Search: 'Buscar',
  RemoveMember: 'Eliminar miembro',
  RemoveMembers: 'Eliminar miembros',
  PleaseSelect: 'Por favor seleccione',
  Role: 'Rol',
  Scope: 'Contexto',
  ScopeType: 'Tipo de Contexto',
  RolesAssigned: 'Roles Asignados',
  SearchScope: 'Contexto de búsqueda',
  GroupParam: 'Grupo {0}',
  Home: 'Home',
  Groups: 'Grupos',
  Members: 'Miembros',
  Roles: 'Roles',
  AddGroup: 'Agregar grupo',
  GroupInfo: 'Información del grupo',
  GroupMembers: 'Miembros del grupo',
  CheckGroupInfoAndUsersTabs: 'Por favor revise la información del grupo y las pestañas de miembros. Algo está mal',
  AddNewGroup: 'Agregar nuevo grupo',
  PleaseEnterName: 'Por favor ingrese un nombre',
  OrganizationDatabaseHasBeenCreated: 'Se ha creado la base de datos de la organización',
  OK: 'OK',
  SomethingWentWrong: 'Algo salió mal',
  OrganizationHasBeenBlocked: 'La organización ha sido bloqueada',
  OrganizationHasBeenUnblocked: 'La organización ha sido desbloqueada',
  Yes: 'Si',
  No: 'No',
  DisplayName: 'Nombre para mostrar',
  Email: 'Correo electrónico',
  Address: 'Dirección',
  PleaseEnterAValidEmail: 'Ingrese un correo electrónico válido',
  PleaseEnterAnAddress: 'Por favor ingrese una dirección',
  DefaultLanguage: 'Idioma predeterminado',
  IsPartner: 'Es Socio',
  IsBlocked: 'Está bloqueado',
  PartnerOrganization: 'Organización socia',
  Unblock: 'Desbloquear',
  Block: 'Bloquear',
  EnsureDB: 'Asegurar BD',
  PleaseCheckTheInfoProvided: 'Por favor, compruebe la información proporcionada. Algo está mal',
  AddMembersToOrganization: 'Agregar miembros a la organización',
  PleaseSelectOrRemoveRow: 'Seleccione o elimine una fila',
  Add: 'Agregar',
  AreYouSureRemoveMemberParam: '¿Está seguro de que desea eliminar a {0} miembro de la organización?',
  AreYouSureRemoveMembersParam: '¿Está seguro de que desea eliminar a {0} miembros de la organización?',
  DeleteUsers: 'Eliminar Usuarios',
  InvitationSent: 'Invitación enviada',
  InvitationNotSent: 'Invitación no enviada',
  ResendInvitation: 'Reenviar invitación',
  OrganizationMembers: 'Miembros de la organización',
  Reload: 'Recargar',
  TypeOrganizationNameToConfirm: 'Escriba el nombre de la organización para confirmar',
  Type: 'Escriba',
  OrganizaciónParam: 'Organización {0}',
  Delete: 'Eliminar',
  CanNotDeleteOrgs: 'No se pueden eliminar organizaciones',
  CanNotdeleteOwnOrganization: 'No se puede eliminar la propia organización',
  AddOrganization: 'Agregar Organización',
  CheckOrganizationInfoAndUserTabs: 'Verifique la información de la organización y las pestañas de usuarios. Algo está mal',
  AddNewOrganization: 'Agregar nueva organización',
  CreatingOrganizationAndItsDatabase: 'Creando organización y su base de datos. Esto podría tomar varios minutos. Espere por favor',
  PleaseSelectALanguage: 'Por favor seleccione un idioma',
  PleaseSelectOrInvite: 'Seleccione o invite',
  SelectOrInviteOrganizationMaster: 'Seleccionar o invitar a la organización principal',
  OrganizationUsers: 'Usuarios de la organización',
  SelectRoles: 'Seleccionar roles',
  AddUser: 'Agregar Usuario',
  PartnerRoles: 'Roles de socios',
  EditPartnerRole: 'Editar rol de socio',
  PleaseSelectASelector: 'Seleccione un selector',
  RoleName: 'Nombre de rol',
  RolesPermissions: 'Permisos de funciones',
  Allow: 'Permitir',
  Deny: 'Negar',
  Selector: 'Selector',
  Edit: 'Editar',
  CreateRole: 'Crear rol',
  NewPartnerRole: 'Nueva función de socio',
  NewRole: 'Nuevo Rol',
  RoleIsBeingAssignedToDefaultCreatorsDelete:
    'Este rol se asigna de forma predeterminada a los creadores de algunos tipos de contexto. ¿Seguro que quieres borrarlo?',
  RoleDelete: '¿Está seguro de que desea eliminar este rol?',
  DefaultRoleDelete: '¿Está seguro de que desea eliminar este rol predeterminado?',
  EditRole: 'Editar rol',
  PleaseSelectAnOrganization: 'Seleccione una organización',
  AddToGroups: 'Agregar a grupos',
  AreYouSureWantRemoveUserFromGroup: '¿Está seguro de que desea eliminar al usuario del grupo {0}?',
  AreYouSureWantRemoveUserFromGroups: '¿Está seguro de que desea eliminar al usuario de {0} grupos?',
  DeleteGroup: 'Borrar grupo',
  DeleteGroups: 'Eliminar grupos',
  RemoveMembership: 'Eliminar membresía',
  RemoveMemberships: 'Eliminar membresías',
  AssignRolesToUser: 'Asignar roles al usuario',
  UserParam: 'Usuario {0}',
  CanNotDeleteOwnUser: 'No se puede eliminar el propio usuario',
  PasswordMustMatch: 'La contraseña debe coincidir',
  AddNewUser: 'Agregar nuevo usuario',
  SetPassword: 'Establecer contraseña',
  ConfirmPassword: 'Confirmar contraseña',
  BlankPasswordWarning:
    'Si deja el campo de contraseña en blanco, el sistema asumirá que este usuario utilizará un proveedor de autenticación externo para iniciar sesión.',
  OrganizationsManagement: 'Gestión de Organizaciones',
  UsersManagement: 'Gestión de usuarios',
  RolesManagement: 'Gestión de roles',
  PartnerRolesManagement: 'Administración de roles de socios',
  GroupsManagement: 'Gestión de grupos',
  BackHome: 'Volver a Home',
  HomeError: 'Lo siento, la página que visitaste no existe.',
  NotFound: 'No encontrado',
  ChangeOrganization: 'Cambiar Organización',
  DeleteUser: 'Eliminar usuario',
  ConfirmDeleteUser: '¿Está seguro de que desea eliminar el usuario "{0}" con la dirección de correo electrónico "{1}"?',
  UserDeleted: 'El usuario "{0}" con la dirección de correo electrónico "{1}" se eliminó con éxito.',

  NotificationTimestampMessageMinutes: 'hace {0} minutos',
  DisplayingFilteredItems: 'Mostrando elementos filtrados por una notificación.',
  ShowAllItems: 'Mostrar todos los elementos',
  NotificationTimestampMessageHours: 'hace {0} horas',
  Yesterday: 'Ayer',
  Read: 'Leído',
  Unread: 'No leído',
  Action: 'Acción',
  AffectedElement: 'Elemento afectado',
  LinkTo: 'Enlace a',
  State: 'Estado',
  Date: 'Fecha',
  Notifications: 'Notificaciones',
  NotificationStatus: 'Estado de la notificación',
  InApp: 'En la aplicación',
  NotificationsSettings: 'Configuración de notificaciones',
  DeleteAfter: 'Eliminar después de',
  OneWeek: 'Una semana',
  OneMonth: 'Un mes',
  OneYear: 'Un año',
  ThreeMonths: 'Tres meses',
  SixMonths: 'Seis meses',
  DeleteAllNotifications: 'Eliminar todas',
  SurveySynchedRingNotificationDescription: 'La medición "{A}" ha sido sincronizada en el pozo "{B}".',
  SurveySynchedDrillholeNotificationDescription: 'La medición "{A}" ha sido sincronizada en el banco "{B}".',
  SurveySynchedQuarantineNotificationDescription: 'La medición "{A}" ha sido sincronizada en la cuarentena.',
  OrganizationCreationFinishedNotificationTitle: 'Organización creada',
  OrganizationExpirationWarningNotificationTitle: 'La organización está por expirar',
  OrganizationCreationErrorNotificationTitle: 'Error al crear la organización',
  OrganizationIsAvailableNotificationTitle: 'Organización disponible',
  LicenseNeedsApprovalNotificationTitle: 'La licencia necesita aprobación',
  LicenseWasRenewedNotificationTitle: 'La licencia fue renovada',
  RingCreatedNotificationTitle: 'Banco creado',
  SurveySynchedNotificationTitle: 'Medición sincronizada',
  ProjectDeletedNotificationTitle: 'Proyecto eliminado',
  ProjectEditedNotificationTitle: 'Proyecto editado',
  DrillholeDeletedNotificationTitle: 'Pozo eliminado',
  RingDeletedNotificationTitle: 'Banco eliminado',
  DrillholeMovedNotificationTitle: 'Pozo movido',
  RingMovedNotificationTitle: 'Banco movido',
  DrillholeEditedNotificationTitle: 'Pozo actualizado',
  RingEditedNotificationTitle: 'Banco actualizado',
  SurveySignoffNotificationTitle: 'Solicitud de aprobación de medición',
  DrillholeCreatedNotificationTitle: 'Pozo creado',
  BulkDrillholesUpdateNotificationTitle: 'Pozos editados',
  BulkDrillholesMovedNotificationTitle: 'Pozos movidos',
  BulkRingsMovedNotificationTitle: 'Bancos movidos',
  BulkDrillholesDeletedNotificationTitle: 'Pozos eliminados',
  BulkRingsDeletedNotificationTitle: 'Bancos eliminados',
  BulkProjectsDeletedNotificationTitle: 'Proyectos eliminados',
  BulkRingsCreatedNotificationTitle: 'Bancos creados',
  BulkDrillholesCreatedNotificationTitle: 'Pozos creados',
  SurveyDeletedNotificationTitle: 'Medición eliminada',
  SurveyDeletedNotificationDescription: 'La medición "{A}" fue eliminada.',

  OrganizationCreationFinishedNotificationDescription: 'La organización {A} fue creada con {X} miembros.',
  OrganizationExpirationWarningNotificationDescription: 'La organización {A} está por expirar.',
  OrganizationCreationErrorNotificationDescription: 'Hubo un error al crear la organización {A}.',
  OrganizationIsAvailableNotificationDescription: 'La organización {A} ya está disponible.',
  LicenseNeedsApprovalNotificationDescription: 'Una licencia con el código de herramienta {A} necesita aprobación.',
  LicenseWasRenewedNotificationDescription: 'Una licencia con el código de herramienta {A} fue renovada.',
  SurveySynchedNotificationDescription: 'La medición "{A}" ha sido sincronizada en el pozo "{B}".',
  ProjectDeletedNotificationDescription: 'El proyecto "{A}" fue eliminado.',
  ProjectEditedNotificationDescription: 'El proyecto "{A}" fue editado.',
  DrillholeDeletedNotificationDescription: 'El pozo "{A}" fue eliminado.',
  RingDeletedNotificationDescription: 'El banco "{A}" fue eliminado.',
  DrillholeMovedNotificationDescription: 'El pozo "{B}" fue movido a "{A}".',
  RingMovedNotificationDescription: 'El banco "{B}" fue movido al proyecto "{A}".',
  DrillholeEditedNotificationDescription: 'El pozo "{A}" fue actualizado',
  RingEditedNotificationDescription: 'El banco "{A}" fue actualizado',
  SurveySignoffNotificationDescription: 'Se solicitó una aprobación para la medición "{A}".',
  DrillholeCreatedNotificationDescription: 'Un pozo de nombre "{B}" ha sido creado en "{A}".',
  RingCreatedNotificationDescription: 'Un banco de nombre "{B}" fue creado en el proyecto "{A}".',
  BulkDrillholesUpdateNotificationDescription: 'Se editaron {X} pozos en "{B}".',
  BulkDrillholesMovedNotificationDescription: 'Se movieron {X} pozos a "{B}".',
  BulkRingsMovedNotificationDescription: 'Se movieron {X} bancos al proyecto "{B}".',
  BulkDrillholesDeletedNotificationDescription: 'Se eliminaron {X} pozos',
  BulkRingsDeletedNotificationDescription: 'Se eliminaron {X} bancos',
  BulkProjectsDeletedNotificationDescription: 'Se eliminaron {X} proyectos.',
  BulkRingsCreatedNotificationDescription: 'Se crearon {X} bancos.',
  BulkDrillholesCreatedNotificationDescription: 'Se crearon {X} pozos en "{B}".',
  ForgotPasswordNotificationTitle: 'Correo de restablecimiento de contraseña enviado',
  OrganizationInvitationNotificationTitle: 'Invitación a organización recibida',
  LicenseQRSharedNotificationTitle: 'Licencia compartida contigo',
  ToolUsageReportNotificationTitle: 'Reporte de uso de herramientas listo',
  OrganizationCreationFinishedNotificationTitleError: 'Error al crear la organización',
  OrganizationIsAvailableNotificationTitleError: 'Error al habilitar la organización',
  LicenseWasRenewedNotificationTitleError: 'Error al renovar la licencia',
  RingCreatedNotificationTitleError: 'Error al crear el banco',
  SurveySynchedNotificationTitleError: 'Error al sincronizar la medición',
  ProjectDeletedNotificationTitleError: 'Error al eliminar el proyecto',
  ProjectEditedNotificationTitleError: 'Error al editar el proyecto',
  DrillholeDeletedNotificationTitleError: 'Error al eliminar el pozo',
  RingDeletedNotificationTitleError: 'Error al eliminar el banco',
  DrillholeMovedNotificationTitleError: 'Error al mover el pozo',
  RingMovedNotificationTitleError: 'Error al mover el banco',
  DrillholeEditedNotificationTitleError: 'Error al actualizar el pozo',
  RingEditedNotificationTitleError: 'Error al actualizar el banco',
  DrillholeCreatedNotificationTitleError: 'Error al crear el pozo',
  BulkDrillholesUpdateNotificationTitleError: 'Error al editar los pozos',
  BulkDrillholesMovedNotificationTitleError: 'Error al mover los pozos',
  BulkRingsMovedNotificationTitleError: 'Error al mover los bancos',
  BulkDrillholesDeletedNotificationTitleError: 'Error al eliminar los pozos',
  BulkRingsDeletedNotificationTitleError: 'Error al eliminar los bancos',
  BulkProjectsDeletedNotificationTitleError: 'Error al eliminar los proyectos',
  BulkRingsCreatedNotificationTitleError: 'Error al crear los bancos',
  BulkDrillholesCreatedNotificationTitleError: 'Error al crear los pozos',
  SurveyDeletedNotificationTitleError: 'Error al eliminar la medición',
  ForgotPasswordNotificationTitleError: 'Error al enviar el correo de restablecimiento de contraseña',
  OrganizationInvitationNotificationTitleError: 'Error al enviar la invitación a la organización',
  LicenseQRSharedNotificationTitleError: 'Error al compartir la licencia',
  ToolUsageReportNotificationTitleError: 'Error al generar el informe de uso de las herramientas',

  SurveyDeletedNotificationDescriptionError: 'Hubo un error al eliminar la medición "{A}".',
  OrganizationCreationFinishedNotificationDescriptionError: 'Hubo un error al crear la organización {A}.',
  OrganizationIsAvailableNotificationDescriptionError: 'Hubo un error al habilitar la organización {A}.',
  LicenseWasRenewedNotificationDescriptionError: 'Hubo un error al renovar la licencia con código de herramienta {A}.',
  SurveySynchedNotificationDescriptionError: 'Hubo un error al sincronizar la medición "{A}" en el pozo "{B}".',
  ProjectDeletedNotificationDescriptionError: 'Hubo un error al eliminar el proyecto "{A}".',
  ProjectEditedNotificationDescriptionError: 'Hubo un error al editar el proyecto "{A}".',
  DrillholeDeletedNotificationDescriptionError: 'Hubo un error al eliminar el pozo "{A}".',
  RingDeletedNotificationDescriptionError: 'Hubo un error al eliminar el banco "{A}".',
  DrillholeMovedNotificationDescriptionError: 'Hubo un error al mover el pozo "{B}" a "{A}".',
  RingMovedNotificationDescriptionError: 'Hubo un error al mover el banco "{B}" al proyecto "{A}".',
  DrillholeEditedNotificationDescriptionError: 'Hubo un error al actualizar el pozo "{A}".',
  RingEditedNotificationDescriptionError: 'Hubo un error al actualizar el banco "{A}".',
  DrillholeCreatedNotificationDescriptionError: 'Hubo un error al crear el pozo "{A}" en "{B}".',
  RingCreatedNotificationDescriptionError: 'Hubo un error al crear el banco "{A}" en el proyecto "{B}".',
  BulkDrillholesUpdateNotificationDescriptionError: 'Hubo un error al editar {X} pozos en "{B}".',
  BulkDrillholesMovedNotificationDescriptionError: 'Hubo un error al mover {X} pozos a "{A}".',
  BulkRingsMovedNotificationDescriptionError: 'Hubo un error al mover {X} bancos al proyecto "{A}".',
  BulkDrillholesDeletedNotificationDescriptionError: 'Hubo un error al eliminar {X} pozos.',
  BulkRingsDeletedNotificationDescriptionError: 'Hubo un error al eliminar {X} bancos.',
  BulkProjectsDeletedNotificationDescriptionError: 'Hubo un error al eliminar {X} proyectos.',
  BulkRingsCreatedNotificationDescriptionError: 'Hubo un error al crear {X} bancos.',
  BulkDrillholesCreatedNotificationDescriptionError: 'Hubo un error al crear {X} pozos en "{B}".',
  ForgotPasswordNotificationDescriptionError: 'Hubo un error al enviar el correo de restablecimiento de contraseña.',
  OrganizationInvitationNotificationDescriptionError: 'Hubo un error con una invitación a la organización. Por favor, verifique.',
  LicenseQRSharedNotificationDescriptionError: 'Hubo un error al compartir la licencia.',
  ToolUsageReportNotificationDescriptionError: 'Hubo un error al generar o enviar el informe de uso de las herramientas.',
  SurveySynchedRingNotificationDescriptionError: 'Hubo un error al sincronizar la medición "{A}" en el pozo "{B}".',
  SurveySynchedDrillholeNotificationDescriptionError: 'Hubo un error al sincronizar la medición "{A}" en el banco "{B}".',
  SurveySynchedQuarantineNotificationDescriptionError: 'Hubo un error al sincronizar la medición "{A}" en la cuarentena.',
  IsRead: 'Leído',
  RelatedEntityName: 'Nombre de entidad relacionada',
  RelatedEntityType: 'Tipo de entidad relacionada',
  RedirectEntityName: 'Nombre de entidad de redirección',
  RedirectEntityType: 'Tipo de entidad de redirección',
  Count: 'Cantidad',
  Enable: 'Habilitar',
  SendNotificationsViaEmail: 'Enviar notificaciones por correo electrónico',
  Title: 'Título',
  Description: 'Description',
  TypeHeader: 'Tipo',

  ForgotPasswordNotificationDescription: 'Se ha enviado un correo electrónico con un enlace para restablecer tu contraseña.',
  OrganizationInvitationNotificationDescription:
    'Has sido invitado a unirte a una organización. Por favor revisa tu correo electrónico para más detalles.',
  LicenseQRSharedNotificationDescription: 'Se ha compartido una licencia contigo. Por favor revisa tu correo electrónico para más detalles.',
  ToolUsageReportNotificationDescription: 'El reporte de uso de herramientas fue generado exitosamente y enviado a tu correo electrónico.',

  Now: 'Ahora',
  EmptyNotificationsTextTitle: '¡Ya estás al día!',
  EmptyNotificationsTextSubtitle: 'No tiene nuevas notificaciones',
  LastWeek: 'La semana pasada',
  Today: 'Hoy',
  ThisWeek: 'Esta semana',
  ThisMonth: 'Este mes',
  MarkAsRead: 'Marcar como leída',
  MarkAsReadAll: 'Marcar como leídas',

  //Permissions
  //Admin
  CreatePartnerOrganization: 'Crear organización asociada',
  DeletePartnerOrganization: 'Eliminar organización asociada',
  ManageDefaultRoles: 'Administrar roles predeterminados',
  ManagePermissions: 'Administrar permisos',
  //Partners
  BlockOrganization: 'Bloquear organización',
  CreateOrganization: 'Crear Organización',
  DeleteOrganization: 'Eliminar Organización',
  ManageLicenses: 'Administrar licencias',
  ManageRoleAssignment: 'Administrar asignaciones de roles',
  //Organization
  CreateProject: 'Crear Proyecto',
  ManageGroups: 'Administrar grupos',
  ManageOrganizationInfo: 'Administrar información de la organización',
  ManageOrganizationRoleAssignments: 'Administrar asignaciones de funciones de la organización',
  ManageQuarantine: 'Administrar cuarentena',
  ManageRecycleBin: 'Administrar papelera de reciclaje',
  ManageRoles: 'Administrar roles',
  ManageUnitSystem: 'Gestionar sistema de unidades',
  ManageUnitSystems: 'Gestionar sistemas de unidades',
  ManageUsers: 'Administrar usuarios',
  //Project
  CreateDrillhole: 'Crear pozo',
  DeleteProject: 'Eliminar proyecto',
  ManageProjectInfo: 'Administrar información del proyecto',
  ManageProjectRoleAssignments: 'Gestionar asignaciones de funciones del proyecto',
  ViewProjectData: 'Ver datos del proyecto',
  //Ring
  CreateRing: 'Crear banco',
  DeleteRing: 'Eliminar banco',
  ManageRingInfo: 'Administrar información de banco',
  ManageRingRoleAssignments: 'Administrar asignaciones de roles de banco',
  ShareRing: 'Compartir banco',
  ViewRingData: 'Ver datos de banco',
  CreateRingDrillhole: 'Crear pozos de banco',
  //Drillhole
  DeleteDrillhole: 'Eliminar pozo',
  ManageDrillholeInfo: 'Administrar información de pozos',
  ManageDrillholeRoleAssignments: 'Administrar asignaciones de roles de perforación',
  ViewDrillholeData: 'Ver datos de pozos',
  ManageSurveys: 'Administrar mediciones',
  SynchronizeSurveys: 'Sincronizar mediciones',
  WelcomBackParam: '¡Bienvenido de nuevo, {0}!',
  Change: 'Cambiar',
  Unauthorized: 'No autorizado',
  YouDontHaveAccessToSite: 'No tiene acceso al centro de socios',
  LoginOutInSecondsParam: 'Cerrar sesión en {0} segundos',
  AssignRoleWarning:
    'Está asignando los roles: {0} a {1} a nivel de organización. Los roles se aplicarán a todas las entidades seleccionadas y {1} tendrá permiso para toda la información contenida en {2}',
  UpdateExpiredRoleWarning:
    'Los roles: {0} fueron asignados previamente a {1}, pero han expirado. La fecha seleccionada reemplazará la fecha de expiración anterior y los roles volverán a estar activos.',
  DoYouWantToContinue: '¿Quiere continuar?',
  MemberAlreadyInOrganizarion: 'El usuario ya es un miembro de la organización {0}',
  YouHaveSelectedThisUserMoreThanOnce: 'Este usuario ha sido seleccionado más de una vez',
  ClearFilter: 'Quitar filtro',
  ElementsSussessfulyDeleted: 'Elementos eliminados con éxito',
  DownloadErrorsFile: 'Descargar archivo de errores',
  Errors: 'Errores',
  DownloadWarningsFile: 'Descargar archivo de advertencias',
  Warnings: 'Advertencias',
  FailDeletion: 'Borrado fallido',
  OrderBy: 'Ordenar por',
  rowsSelected: 'fila(s) seleccionada(s)',
  AddNew: 'Agregar nuevo',
  DeleteAll: 'Borrar todo',
  ImportCSV: 'Importar CSV',
  BulkUploadItems: 'Subir conjunto de elementos',
  Licenses: 'Licencias',
  ToolCode: 'Código de Herramienta',
  DeviceType: 'Tipo de Dispositivo',
  FromDate: 'Desde la Fecha',
  UntilDate: 'Hasta la Fecha',
  CreatedOn: 'Creado En',
  CreatedBy: 'Creado por',
  Unlimited: 'Ilimitado',
  Coefficients: 'Coeficientes',
  Continuous: 'Continuo',
  Multishot: 'Multidisparo',
  Zupt: 'Zupt',
  Offline: 'Desconectado',
  Flash: 'Flash',
  Notes: 'Notas',
  AddLicense: 'Crear Licencia',
  AddNewLicense: 'Crear Nueva Licencia',
  PleaseEnterToolCode: 'Entre el código de la herramienta',
  LicenseCopied: 'Licencia copiada al portapapeles',
  License: 'Licencia',
  Copy: 'Copiar',
  ErrorLoadingLicense: 'Error al cargar la licencia',
  ShowLicense: 'Mostrar Licencia',
  LicenseAlreadyExists:
    'Está intentando crear una nueva licencia para {0} #{1} desde {6} hasta {7}, pero ya existe una licencia creada para {0} #{1} desde {2} hasta {3} por {4} el {5}. ¿Desea continuar y crear una nueva licencia de todos modos?',
  UnlimitedLicenseAlreadyExists:
    'Ya existe una licencia ilimitada creada para {0} #{1} por {2} el {3}. ¿Desea continuar y crear una nueva licencia de todos modos?',
  Continue: 'Continuar',
  PeriodOfValidity: 'Periodo de Validez',
  CopyLicense: 'Copiar Licencia',
  CopyAll: 'Copiar Todo',
  PleaseSelectDates: 'Por favor, seleccione el rango de fechas',
  Project: 'Proyecto',
  Customer: 'Cliente',
  ExportCSV: 'Exportar CSV',
  Reports: 'Reportes',
  Export: 'Exportar',
  Separator: 'Separador',
  Tab: 'Tab',
  Semicolon: 'Punto y coma',
  Comma: 'Coma',
  AreYouSureYouWantToDelete: '¿Está seguro de que desea eliminar los elementos seleccionados?',
  AreYouSureYouWantToDeleteSelected: '¿Está seguro de que desea eliminar los elementos seleccionados?',
  ThereWasAProblemCreatingLicense: 'Hubo un problema al crear la licencia. Por favor, comuníquese con un administrador.',
  ExpirationDate: 'Fecha de vencimiento',
  UpdateRoleAttributes: 'Actualizar atributos de rol',
  Update: 'Actualizar',
  AllowedDevices: 'Dispositivos Permitidos',
  RoleExpirationDate: 'Fecha de vencimiento del rol',
  PleaseEnterExpirationDate: 'Por favor, ingrese una fecha de vencimiento',
  MaximumLicenseDueDate: 'Fecha máxima de vencimiento de la licencia',
  PleaseEnterMaxDueDate: 'Por favor, ingrese la fecha máxima de vencimiento de la licencia',
  MaxLicensesPeriodInDays: 'Período máximo de licencia en días',
  PleaseEnterMaxLicensesPeriodInDays: 'Por favor, ingrese el período máximo de licencia en días',
  MaxNumberOfLicensesPerMonth: 'Número máximo de licencias por mes',
  PleaseEnterMaxNumberOfLicensesPerMonth: 'Por favor, ingrese el número máximo de licencias por mes',
  DeleteElements: 'Eliminar elementos',
  DeleteItems: 'Eliminar elementos',
  DeleteSelected: 'Eliminar seleccionado',
  DeviceTypeNotAllowed: 'Usted no está autorizado a crear licencias para el dispositivo seleccionado',
  MaximumLicenseDueDateReached: 'Usted no está autorizado a crear licencias con una fecha de vencimiento posterior a {0}',
  MaxLicensesPeriodInDaysReached: 'Las licencias creadas deben ser válidas por un período de a lo sumo {0} días.',
  MaxNumberOfLicensesPerMonthReached:
    'Usted ha alcanzado el máximo número de licencias que pueden ser creadas en un mes. Por favor, espere al próximo mes para crear una nueva licencia.',
  ApprovalPending: 'Aprobación Pendiente',
  InitializingOrganization: 'Inicializando Organización. Los usuarios estarán disponibles pronto',
  InvalidToolCode: 'El código de la herramienta debe tener exactamente cuatro dígitos',
  EditRoles: 'Editar roles',
  EditRolesMessage: 'Editar roles de usuario',
  RolesWillBeRemoved: 'Se eliminarán los siguientes roles: {0}. ',
  RolesWillBeAssigned: 'Se asignarán los siguientes roles: {0}. ',
  ThisUserIsOrganizationMaster: 'Este usuario ya ha sido seleccionado como maestro de la organización',
  RemainingLicensesMessage: 'Le quedan un total de {0} licencias para este mes',
  MaxLicenseNumberReached: 'Ha alcanzado el número máximo de licencias para este mes',
  EULATitle: 'Acuerdo de licencia de usuario final (EULA)',
  OrganizationIsExporting: 'La organización se está exportando, por favor espere...',
  ErrorExportingOrganization: 'Se ha producido un error al exportar la organización {0}. Por favor, inténtelo de nuevo',
  ExportingOrganizationSuccess: 'El proceso de exportación ha comenzado, cuando termine enviaremos el enlace de descarga a su correo electrónico.',
  CanNotDeleteOrganizationWhileExporting:
    'La organización {0} está siendo exportada y no puede ser eliminada en este momento. Por favor, espere y vuelva a intentarlo dentro de un rato.',
  CheckingIfOrganizationExists: 'Comprobando si la organización existe...',
  RestoreOrganizationConfirmDialog:
    'Esta organización ya existe, ¿desea continuar? Todos los datos de esta organización se sobrescribirán con los datos de la copia de seguridad.',
  ExportingProcessStarted: 'El proceso de exportación ha comenzado, la descarga comenzará en breve',
  ExportOrganization: 'Exportar Organización',
  ImportOrganization: 'Importar Organización',
  UploadOrganizationBackup: 'Subir copia de seguridad de la organización',
  AddOrganizationFile: 'Haga clic o arrastre el archivo de copia de seguridad de la organización a esta área para cargar',
  ImportingOrganizationStarted: 'El proceso de importación ha comenzado',
  ImportingOrganizationSuccess: 'El proceso de importación ha comenzado, cuando termine enviaremos una notificación a su correo electrónico.',
  ErrorImportingOrganization: 'Se ha producido un error al importar la organización. Por favor, inténtelo de nuevo',
  Importing: 'Importando...',
  LastImportDate: 'Esta organización se restauró por última vez a partir de una copia de seguridad el ',
  ShowOrganizationLicenses: 'Licencias de organización',
  ShowAll: 'Mostrar todo',

  GroupsTableError: 'Se ha producido un error al cargar los grupos. Por favor, inténtelo de nuevo',
  ErrorSavingGroupProperties: 'Se ha producido un error al guardar las propiedades del grupo. Please try again',
  ErrorAddingGroupMembers: 'Se ha producido un error al añadir los miembros al grupo. Por favor, inténtelo de nuevo',
  GroupRolesTableError: 'Se ha producido un error al cargar los roles del grupo. Inténtelo de nuevo',
  LicensesTableError: 'Se ha producido un error al cargar las licencias. Por favor, inténtelo de nuevo',
  OrganizationsTableError: 'Se ha producido un error al cargar las organizaciones. Por favor, inténtelo de nuevo',
  ErrorAddingOrganizationMembers: 'Se ha producido un error al añadir los nuevos miembros a la organización. Por favor, inténtelo de nuevo',
  ErrorRemovingOrganizationMembers: 'Se ha producido un error al eliminar los nuevos miembros de la organización. Por favor, inténtelo de nuevo',
  RoleListTableError: 'Se ha producido un error al cargar los roles. Por favor, inténtelo de nuevo',
  UsersTableError: 'Se ha producido un error al cargar la lista de usuarios. Inténtalo de nuevo',
  ErrorAddingGroup: 'Se ha producido un error al añadir el grupo. Por favor, inténtalo de nuevo',
  ErrorRemovingGroup: 'Se ha producido un error al eliminar el grupo. Inténtalo de nuevo',
  UserRolesTableError: 'Se ha producido un error al cargar los roles de usuario. Inténtelo de nuevo',
  InvitationNotSentErrorMessage: 'Se ha producido un error al enviar la invitación. Please try again',
  ErrorDeletingUser: 'Se ha producido un error al eliminar el usuario. Por favor, inténtelo de nuevo.',
  PartnerRolesTableError: 'Se ha producido un error al cargar los roles de socio. Por favor, inténtelo de nuevo.',
  PaginationTotal: 'Mostrando {0} elementos de {1}',
  CheckDB: 'Verificar base de datos',
  Drillhole: 'Pozo',
  ShareDrillhole: 'Compartir pozo',
  SignOffSurveys: 'Firmar mediciones',
  SelectOrInviteUser: 'Seleccionar o invitar usuario',
  SelectOrInviteUsers: 'Seleccionar o invitar usuarios',
  ManageGlobalLicenses: 'Administrar licencias globales',
  ManageRoleAssignments: 'Administrar asignación de roles globales',
  ViewSurveyData: 'Ver datos de medición',
  Organizations: 'Organizaciones',
  SelectSelector: 'Seleccionar Selector',
  SelectOrganization: 'Seleccionar organización',
  GroupMembership: 'Membresía del grupo',
  SelectEntity: 'Seleccionar entidad',
  Users: 'Usuarios',
  AddUserToGroups: 'Agregar usuario a grupos',
  SelectLanguage: 'Seleccionar idioma',
  English: 'English',
  Spanish: 'Español',
  Portuguese: 'Português',
  Russian: 'русский',
  French: 'Français',
  Restore: 'Restore',
  RestoreBackupConfirmMessage:
    '¿Desea restaurar esta copia de seguridad? Se perderá cualquier cambio realizado en la organización después de crear la copia de seguridad',
  RestoreBackupSuccess: 'El proceso de restauración de la copia de seguridad ha comenzado. Cuando termine le enviaremos un correo electrónico.',
  Backups: 'Copias de seguridad',
  OrganizationBackups: 'Copias de seguridad de las organizaciones',
  OrganizationName: 'Nombre de la Organización',
  Statistics: 'Estadísticas',
  Last24Hours: 'Últimas 24 horas',
  Last3Days: 'Últimos 3 días',
  Last7Days: 'Últimos 7 días',
  Last28Days: 'Últimos 28 días',
  FilterByDate: 'Filtrar por fecha',
  Projects: 'Proyectos',
  Surveys: 'Mediciones',
  ProjectsNumber: 'Número de proyectos',
  UsersNumber: 'Número de usuarios',
  SurveysNumber: 'Número de mediciones',
  CreationDate: 'Fecha de creación',
  LastUpdate: 'Última actualización',
  CustomDateRange: 'Rango de fechas personalizado',
  OrganizationIsLocked:
    'Esta organización está actualmente bloqueada porque está siendo utilizada en otro proceso. Por favor, espere y vuelva a intentarlo dentro de un rato.',
  SelectGroups: 'Seleccionar Grupos',
  ErrorUpdatingRole: 'Hubo un error al actualizar los permisos del rol. Por favor, inténtelo de nuevo.',

  WorkingHours: 'Horas de trabajo',
  PleaseEnterWorkingHours: 'Por favor, ingrese las horas de trabajo',

  Country: 'País',
  PleaseSelectCountry: 'Por favor, seleccione un país',

  // Country names
  Afghanistan: 'Afganistán',
  Albania: 'Albania',
  Algeria: 'Argelia',
  Andorra: 'Andorra',
  Angola: 'Angola',
  'Antigua and Barbuda': 'Antigua y Barbuda',
  Argentina: 'Argentina',
  Armenia: 'Armenia',
  Australia: 'Australia',
  Austria: 'Austria',
  Azerbaijan: 'Azerbaiyán',
  Bahamas: 'Bahamas',
  Bahrain: 'Baréin',
  Bangladesh: 'Bangladés',
  Barbados: 'Barbados',
  Belarus: 'Bielorrusia',
  Belgium: 'Bélgica',
  Belize: 'Belice',
  Benin: 'Benín',
  Bhutan: 'Bután',
  Bolivia: 'Bolivia',
  'Bosnia and Herzegovina': 'Bosnia-Herzegovina',
  Botswana: 'Botsuana',
  Brazil: 'Brasil',
  Brunei: 'Brunéi',
  Bulgaria: 'Bulgaria',
  'Burkina Faso': 'Burkina Faso',
  Burundi: 'Burundi',
  Cambodia: 'Camboya',
  Cameroon: 'Camerún',
  Canada: 'Canadá',
  'Cape Verde': 'Cabo Verde',
  'Central African Republic': 'República Centroafricana',
  Chad: 'Chad',
  Chile: 'Chile',
  China: 'China',
  Colombia: 'Colombia',
  Comoros: 'Comoras',
  'Costa Rica': 'Costa Rica',
  'Côte d’Ivoire': 'Costa de Marfil',
  Croatia: 'Croacia',
  Cuba: 'Cuba',
  Cyprus: 'Chipre',
  'Czech Republic': 'República Checa',
  'Democratic Republic of the Congo': 'República Democrática del Congo',
  Denmark: 'Dinamarca',
  Djibouti: 'Yibuti',
  Dominica: 'Dominica',
  'Dominican Republic': 'República Dominicana',
  'East Timor': 'Timor Oriental',
  Ecuador: 'Ecuador',
  Egypt: 'Egipto',
  'El Salvador': 'El Salvador',
  'Equatorial Guinea': 'Guinea Ecuatorial',
  Eritrea: 'Eritrea',
  Estonia: 'Estonia',
  Ethiopia: 'Etiopía',
  Fiji: 'Fiyi',
  Finland: 'Finlandia',
  France: 'Francia',
  Gabon: 'Gabón',
  Gambia: 'Gambia',
  Georgia: 'Georgia',
  Germany: 'Alemania',
  Ghana: 'Ghana',
  Greece: 'Grecia',
  Grenada: 'Granada',
  Guatemala: 'Guatemala',
  Guinea: 'Guinea',
  'Guinea-Bissau': 'Guinea-Bisáu',
  Guyana: 'Guyana',
  Haiti: 'Haití',
  Honduras: 'Honduras',
  Hungary: 'Hungría',
  Iceland: 'Islandia',
  India: 'India',
  Indonesia: 'Indonesia',
  Iran: 'Irán',
  Iraq: 'Irak',
  Ireland: 'Irlanda',
  Israel: 'Israel',
  Italy: 'Italia',
  Jamaica: 'Jamaica',
  Japan: 'Japón',
  Jordan: 'Jordania',
  Kazakhstan: 'Kazajistán',
  Kenya: 'Kenia',
  Kiribati: 'Kiribati',
  Kuwait: 'Kuwait',
  Kyrgyzstan: 'Kirguistán',
  Laos: 'Laos',
  Latvia: 'Letonia',
  Lebanon: 'Líbano',
  Lesotho: 'Lesoto',
  Liberia: 'Liberia',
  Libya: 'Libia',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Lituania',
  Luxembourg: 'Luxemburgo',
  Madagascar: 'Madagascar',
  Malawi: 'Malaui',
  Malaysia: 'Malasia',
  Maldives: 'Maldivas',
  Mali: 'Malí',
  Malta: 'Malta',
  'Marshall Islands': 'Islas Marshall',
  Mauritania: 'Mauritania',
  Mauritius: 'Mauricio',
  Mexico: 'México',
  Micronesia: 'Micronesia',
  Moldova: 'Moldavia',
  Monaco: 'Mónaco',
  Mongolia: 'Mongolia',
  Montenegro: 'Montenegro',
  Morocco: 'Marruecos',
  Mozambique: 'Mozambique',
  Myanmar: 'Birmania',
  Namibia: 'Namibia',
  Nauru: 'Nauru',
  Nepal: 'Nepal',
  Netherlands: 'Países Bajos',
  'New Zealand': 'Nueva Zelanda',
  Nicaragua: 'Nicaragua',
  Niger: 'Níger',
  Nigeria: 'Nigeria',
  'North Korea': 'Corea del Norte',
  Norway: 'Noruega',
  Oman: 'Omán',
  Pakistan: 'Pakistán',
  Palau: 'Palaos',
  Panama: 'Panamá',
  'Papua New Guinea': 'Papúa Nueva Guinea',
  Paraguay: 'Paraguay',
  Peru: 'Perú',
  Philippines: 'Filipinas',
  Poland: 'Polonia',
  Portugal: 'Portugal',
  Qatar: 'Catar',
  'Republic of the Congo': 'República del Congo',
  'Republic of Macedonia': 'República de Macedonia',
  Romania: 'Rumania',
  Russia: 'Rusia',
  Rwanda: 'Ruanda',
  'Saint Kitts and Nevis': 'San Cristóbal y Nieves',
  'Saint Lucia': 'Santa Lucía',
  'Saint Vincent and the Grenadines': 'San Vicente y las Granadinas',
  Samoa: 'Samoa',
  'San Marino': 'San Marino',
  'Sao Tome and Principe': 'Sao Tomé y Príncipe',
  'Saudi Arabia': 'Arabia Saudita',
  Senegal: 'Senegal',
  Serbia: 'Serbia',
  Seychelles: 'Seychelles',
  'Sierra Leone': 'Sierra Leona',
  Singapore: 'Singapur',
  Slovakia: 'Eslovaquia',
  Slovenia: 'Eslovenia',
  'Solomon Islands': 'Islas Salomón',
  Somalia: 'Somalia',
  'South Africa': 'Sudáfrica',
  'South Korea': 'Corea del Sur',
  'South Sudan': 'Sudán del Sur',
  Spain: 'España',
  'Sri Lanka': 'Sri Lanka',
  Sudan: 'Sudán',
  Suriname: 'Surinam',
  Swaziland: 'Suazilandia',
  Sweden: 'Suecia',
  Switzerland: 'Suiza',
  Syria: 'Siria',
  Tajikistan: 'Tayikistán',
  Tanzania: 'Tanzania',
  Thailand: 'Tailandia',
  Togo: 'Togo',
  Tonga: 'Tonga',
  'Trinidad and Tobago': 'Trinidad y Tobago',
  Tunisia: 'Túnez',
  Turkey: 'Turquía',
  Turkmenistan: 'Turkmenistán',
  Tuvalu: 'Tuvalu',
  Uganda: 'Uganda',
  Ukraine: 'Ucrania',
  'United Arab Emirates': 'Emiratos Árabes Unidos',
  'United Kingdom': 'Reino Unido',
  'United States of America': 'Estados Unidos',
  Uruguay: 'Uruguay',
  Uzbekistan: 'Uzbekistán',
  Vanuatu: 'Vanuatu',
  Venezuela: 'Venezuela',
  Vietnam: 'Vietnam',
  Yemen: 'Yemen',
  Zambia: 'Zambia',
  Zimbabwe: 'Zimbabue',

  TestOrganization: 'Organización de prueba',
  RemovalDate: 'Fecha de eliminación',
  IsTestOrganization: 'Es una organización de prueba',
  TestingEndDate: 'Fecha de fin de la prueba:',
  TestOrgConfirmationMessage:
    'La entidad ha sido establecida como una organización de prueba y se eliminará automáticamente en la fecha seleccionada. ¿Está seguro de que desea continuar?',

  Show: 'Mostrar',
  Changed: 'Cambiado',
  Unchanged: 'Sin cambios',

  Charts: 'Gráficos',

  CreationChartLegend: 'Creación',
  UpdateChartLegend: 'Actualización',
  LicenseDetails: 'Detalles de la licencia',
  Logout: 'Cerrar Sesión',

  CrashError: '¡Ups! Algo salió realmente mal',
  SeeAllLogs: 'Presione F12 y envíe todos los registros en la pestaña Consola cuando informe este incidente',
  ReturnHome: 'Regresar a Home',

  InvalidEmailWarning: 'Por favor selecciona o ingresa un correo electrónico válido',
  CheckOrganizationInfoAndUsersTabs: 'Verifique la información de la organización y las pestañas de usuarios. Algo está mal',

  UserHasNoOrganizationsWarning:
    'Este usuario no forma parte de ninguna organización. Por favor, agréguelo a una organización antes de asignar roles.',
  UserHasNoOrganizationsGroupWarning:
    'Este usuario no forma parte de ninguna organización. Por favor, agréguelo a una organización antes de añadirlo a grupos.',

  'Customer Geologist': 'Geólogo cliente',
  'Drillhole Manager': 'Administrador de pozos',
  'Field Operator': 'Operador de campo',
  Geologist: 'Geólogo',
  'Global License Manager': 'Administrador de licencias globales',
  'License Manager': 'Administrador de licencias',
  'Organization Coordinator': 'Coordinador de la organización',
  'Organization Master': 'Maestro de la organización',
  'Partner Administrator': 'Administrador de socios',
  'Project Manager': 'Administrador de proyectos',
  'Project Viewer': 'Visualizador de proyectos',
  'Ring Manager': 'Administrador de bancos',

  Partners: 'Socios',

  ActiveHours: 'Horas activa',
  Active: 'Activo',
  NotActive: 'No activo',
  Status: 'Estado',
  Go: 'Ir',
  FilterByActiveDates: 'Filtrar por fechas activa',
  ActiveDays: 'Días activa',

  CanCreateUnlimitedLicense: 'Puede crear licencias que no caducan',
  CanCreateRecurrentLicenses: 'Puede crear licencias recurrentes',
  Recurrence: 'Recurrencia',
  Activated: 'Activado',
  Deactivated: 'Desactivado',

  NeedsSignOff: 'Se necesita aprobación',
  OrganizationParam: 'Organización {0}',
  SelectedUserAlreadyHasTheSelectedRoles: 'El usuario seleccionado ya tiene los roles: {0}.',
  SelectedGroupAlreadyHasTheSelectedRoles: 'El grupo seleccionado ya tiene los roles: {0}.',

  FilterMode: 'Modo de filtrado',
  AllSelected: 'Todos los seleccionados',
  AnyOfTheSelected: 'Cualquiera de los seleccionados',
  Download: 'Descargar',

  RoleAssignmentAttributes: 'Atributos de asignación de roles',
  LicenseManagerRoleAttributes: 'Atributos del rol de administrador de licencias',

  'StructMaster User': 'Usuario de StructMaster',
  UseStructMaster: 'Usar StructMaster',
  StructmasterLicenses: 'Licencias de StructMaster',
  NewStructmasterLicenseAssignment: 'Nueva asignación de licencia de StructMaster',
  EditStructmasterLicenseAssignment: 'Editar asignación de licencia de StructMaster',
  SelectUser: 'Seleccionar usuario',
  UserAlreadyHasStructMasterRole: 'Error: Este usuario ya tiene el rol de StructMaster en esta organización',
  AddAnotherAssignment: 'Agregar otra asignación',
  AddRole: 'Agregar rol',
  SelectRole: 'Seleccionar rol',
  PleaseSelectRole: 'Por favor, seleccione un rol',
  DuplicatedRolesWarning: 'Hay roles duplicados en su selección. Asegúrese de que no haya roles repetidos.',
  RolesWillBeUpdated: 'Se actualizarán los siguientes roles: {0}.',

  UserHasNoRoleWarning: 'El usuario debe tener al menos un rol en la organización',
  UserWillBeAddedToOrganizationBeforeAssign:
    'Advertencia: El usuario "{0}" no pertenece a la organización "{1}", por lo tanto, el usuario "{0}" será añadido a la organización antes de realizar la asignación.',

  ManageCategories: 'Gestionar categorías',
  ManageGeographicInformationSystems: 'Gestionar sistemas de información geográfica',

  Appearance: 'Apariencia',
  DarkTheme: 'Tema oscuro',
  LightTheme: 'Tema claro',
  UseSystemTheme: 'Usar tema del sistema',
  ScheduledMaintenanceText:
    'Mantenimiento programado: La plataforma en la nube estará en mantenimiento programado el {0}. Los servicios pueden verse interrumpidos durante una duración estimada de {1} horas, comenzando a las {2}',
  MFAStatus: 'Estado de autenticación multifactor',
  Enabled: 'Habilitado',
  Disabled: 'Deshabilitado',
  EnableMFA: 'Habilitar autenticación multifactor',
  DisableMFA: 'Deshabilitar autenticación multifactor',

  UserLimit: 'Límite de usuarios',
  PleaseEnterUserLimit: 'Por favor, ingrese el límite de usuarios',
  CheckLicenseInfoAndUsersTabs: 'Por favor, revise la información de la licencia y las pestañas de usuarios. Algo está mal',
  LicenseInfo: 'Información de licencia',
  AddNewStructmasterLicense: 'Agregar nueva licencia StructMaster',
  StructmasterLicense: 'Licencia StructMaster',
  PleaseAddAtLeastOneUser: 'Por favor, agregue al menos un usuario',
  DuplicatedUserWarning: 'Este usuario ya ha sido seleccionado, por favor verifique',
  LicenseName: 'Nombre de la licencia',
  UserAmountExceedLimit: 'La cantidad de usuarios ingresada excede el límite seleccionado, por favor verifique que los datos sean correctos.',

  UserAlreadyIsLicenseManagerError: 'Este usuario ya pertenece a un grupo de administradores de licencias. Por favor, seleccione otro usuario',
  UserAlreadyIsStructmasterUserError: 'Este usuario ya tiene el rol de StructMaster. Por favor, seleccione otro usuario',
  DefaultGroups: 'Grupos predeterminados',
  LicenseManagerGroups: 'Grupos de administradores de licencias',
  UpdateAttributes: 'Actualizar atributos',
  ResetLicenseAccess: 'Restablecer acceso a la licencia',

  UserOnAddGroupAlreadyIsLicenseManagerError:
    'Este usuario ya pertenece a un grupo de administradores de licencias, y hay al menos un grupo de administradores de licencias en su selección. Por favor, revíselo.',
  MoreThanOneLicenseManagerGroupSelectedError:
    'Hay más de un grupo de administradores de licencias en su selección, y un usuario solo puede pertenecer a un único grupo de administradores de licencias. Por favor, revise su selección.',
  Default: 'Predeterminado',

  ThereIsAlreadyAStructmasterLicenseWithThisName: 'Ya existe una licencia de StructMaster con este nombre, por favor seleccione un nombre diferente.',
  ThereIsAlreadyAGroupWithThisName: 'Ya existe un grupo con este nombre, por favor seleccione un nombre diferente',

  GroupLogsTableError: 'Se produjo un error al cargar los registros de auditoría del grupo. Por favor, inténtelo de nuevo.',
  DownloadQR: 'Descargar QR',
  FilterByUser: 'Filtrar por usuario',

  ActiveUser: 'Usuario activo',

  AllowAllPermissionsForThisLevel: 'Permitir todos los permisos para este nivel',
  AllowAllAvailablePermissions: 'Permitir todos los permisos disponibles',
  AllowAllAvaliablePermissionsForThisSelector: 'Permitir todos los permisos disponibles para este selector',

  StructmasterLicensesOnlyOneActiveUserWarning: 'Advertencia: Solo puede haber un usuario activo a la vez por cada licencia de StructMaster.',

  SelectUsersToShare: 'Seleccionar usuarios para compartir',
  SelectOrEnterEmailAddress: 'Seleccionar usuario o ingresar dirección de correo',
  Share: 'Compartir',
  NoUsersSelectedError: 'Por favor, seleccione al menos un usuario o ingrese una dirección de correo electrónico',
  AddEmail: 'Agregar correo electrónico',

  OrganizationUserLimitWarningCreation: 'Advertencia: Solo puede agregar un máximo de {0} usuarios a una organización',
  OrganizationUserLimitWarningParam:
    'Advertencia: Solo puede agregar un máximo de {0} usuarios a esta organización y ya tiene un total de {1}, por lo que solo podrá agregar un total de {2}.',
  OrganizationReachedUserLimit: 'Error: Esta organización ya tiene el número máximo de usuarios permitidos. Por favor seleccione otra organización.',
  NewGroupUserCountErrorParam:
    'Error: Esta organización permite un máximo de {0} usuarios, actualmente tiene {1} usuarios, y está intentando agregar {2} nuevos. Verifique que la información sea correcta.',
  TheFollowingUsersWillBeAddedToTheOrganization: 'Los siguientes usuarios serán añadidos a la organización:',

  UnsignedStructmasterLicenses: 'Licencias StructMaster sin aprobar',
  SaveAndSignOff: 'Guardar y aprobar',
  SignOffStructmasterLicenseWarningTitle: 'Aprobar licencia StructMaster',
  SignOffStructmasterLicenseWarningMessage:
    'Está a punto de aprobar la creación de una nueva licencia StructMaster. Los usuarios se agregarán a la organización seleccionada si aún no están en ella y se les asignará el rol. ¿Desea continuar?',

  ShowOnlyUnsignedLicenses: 'Mostrar solo licencias pendientes de aprobación',
  ClearFilters: 'Limpiar filtros',
  ApproveLicenses: 'Aprobar licencias',
  Save: 'Guardar',

  SoftwareVersion: 'Versión del software',
  AnErrorOcurred: 'Ocurrió un error:',
  DeleteUnsignedLicense: 'Eliminar licencia sin aprobar',
  DeleteUnsignedLicenseWarning: '¿Está seguro de que desea eliminar la licencia sin aprobar "{0}"?',
  SignOff: 'Aprobar',
  Refuse: 'Rechazar',
  ErrorCreatingLicense: 'Error al crear la licencia',
  ErrorUpdatingLicense: 'Error al actualizar la licencia',

  DuplicatedRoleNameErrorCreate:
    'Error al crear el rol: Ya existe un rol con el nombre "{0}" en la organización "{1}". Por favor, ingrese un nombre diferente.',
  DuplicatedRoleNameErrorUpdate:
    'Error al actualizar el rol: Ya existe un rol con el nombre "{0}" en la organización "{1}". Por favor, ingrese un nombre diferente.',
  DuplicatedDefaultRoleNameErrorUpdate:
    'Error al actualizar el rol: Ya existe un rol predeterminado con el nombre "{0}". Por favor, ingrese un nombre diferente.',
  PleaseEnterAValidSearchTerm: 'Por favor, introduzca un término de búsqueda válido',
  TextFieldLimitError: 'El campo "{0}" no debe exceder de {1} caracteres',
  InvalidToolcode: 'Por favor, ingresa un código de herramienta válido',
  LicenseManagerGroupsMustHaveAtLeastOneRole: 'Los grupos de administradores de licencias deben tener al menos un rol',
  PleaseSelectAtLeastOneDeviceType: 'Por favor seleccione al menos un tipo de dispositivo',
  Language: 'Lenguaje',
  NoData: 'Sin datos',
  PleaseEnterCoreDiameter: 'Por favor, introduzca el diámetro del núcleo',
  CoreDiameter: 'Diámetro del núcleo',
  SmartCoreLicenseAlreadyExists:
    'Estás intentando crear una nueva licencia para {0} #{1} con diámetro de herramienta "{8}" de {6} a {7}, pero ya existe una licencia creada para {0} #{1} con diámetro de herramienta "{8}" de {2} a {3} por {4} el {5}. ¿Quieres continuar y crear una nueva licencia de todos modos?',
  UnlimitedSmartCoreLicenseAlreadyExists:
    'Ya existe una licencia ilimitada creada para {0} #{1} con diámetro de herramienta "{8}" por {2} el {3}. ¿Quieres continuar y crear una nueva licencia de todos modos?',
  ToolDiameter: 'Diámetro de la herramienta',
  ToolcodeTooLarge: 'El código de la herramienta es demasiado grande. El código debe ser un número entre 1 y 65535',
  'License Reviewer': 'Revisor de licencias',
  'Client Manager': 'Administrador de clientes',
  MeasurementCount: 'Mediciones',
  ToolSerialNumber: 'Número de serie de la herramienta',
  ExportCsvReport: 'Exportar informe CSV',
  ToolType: 'Tipo de herramienta',
  FirstUsedOn: 'Fecha de primer uso',
  LastUsedOn: 'Fecha de último uso',
  ErrorGeneratingReport: 'Hubo un error al generar el informe. Por favor, inténtelo de nuevo.',
  ToolUsageReport: 'Informe de uso de herramientas',
  ExportToolUsageReport: 'Exportar informe de uso de herramientas',
  ToolUsageReportInProcess:
    'El informe de uso de la herramienta está siendo generado. Se enviará a tu dirección de correo electrónico cuando esté listo.',
  ProjectName: 'Nombre del proyecto',
  Group: 'Grupo',
  SelectOrInviteWarning: 'Por favor selecciona o invita',
  ManagePartnerOrganization: 'Administrar organización de socios',
  ManageAdminOrganization: 'Administrar organización administradora',
};
